import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/* Universal admin Back button (Aug 2026). Uses real browser history so
   filters, search params and list state on the previous page survive.
   Hidden on portal home pages and when there's nowhere to go back to. */

const ROOTS = new Set(["/admin", "/admin/", "/console", "/console/"]);

export const AdminBackButton = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const canGoBack = (window.history.state?.idx ?? 0) > 0;
  if (ROOTS.has(pathname) || !canGoBack) return null;
  return (
    <button
      type="button"
      onClick={() => navigate(-1)}
      data-testid="admin-back-button"
      className="mb-4 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-[10px] tracking-[0.25em] uppercase font-semibold transition hover:shadow-sm"
      style={{ borderColor: "#C9A268", color: "#6E1E3A", backgroundColor: "rgba(255,255,255,0.75)" }}
    >
      <ArrowLeft className="w-3.5 h-3.5" /> Back
    </button>
  );
};
